import React, {useState} from 'react';

import DEFAULT_IMAGE from '../../../../assets/images/welcome-pwa/welcome-pwa-image.png';
import GuideVideo from '../../../components/Video/GuideVideo/GuideVideo';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import SignedImage from '../../System/SignedImage';
import welcomePwaDataService from './welcomePwaDataService';

const WelcomePwaMedia = () => {
    const [isVideoError, setIsVideoError] = useState(false);
    const {videoSrc, thumbnailSrc, imagePath} = welcomePwaDataService.getMediaData();
    const localizedStrings = getLocalizedStrings();

    const onError = () => {
        setIsVideoError(true);
    };

    return (
        <div className='flex h-[250px] w-full items-center justify-center lg:mr-8 lg:h-[408px] lg:w-auto lg:overflow-hidden lg:rounded-[24px]'>
            {!isVideoError && videoSrc ? (
                <GuideVideo
                    src={videoSrc}
                    thumbnailSrc={thumbnailSrc}
                    controlAriaLabel={localizedStrings[localizationKeys.WELCOME_PWA_VIDEO_CONTROL_ARIA_LABEL]}
                    containerClassName='w-full h-full'
                    className='absolute h-full w-full object-cover lg:relative lg:w-auto'
                    controlsClassName='m-0 right-4 left-[unset] z-20 rtl:left-4 rtl:right-[unset]'
                    onError={onError}
                />
            ) : (
                <SignedImage
                    imgClassName='w-full h-full object-cover'
                    mediaData={imagePath}
                    defaultImage={DEFAULT_IMAGE}
                    signIfNull
                />
            )}
        </div>
    );
};

export default WelcomePwaMedia;
